import * as React from "react";
import { Dropdown, IDropdownOption, ResponsiveMode } from "office-ui-fabric-react/lib/Dropdown";

interface IMyDropdownProps {
    id: string;
    gridArea: string;
    isRequired: boolean;
    isVisible: boolean;
    labelText: string;
    onChange: (value: any) => void;
    options: IDropdownOption[];
    submitClicked: boolean;
}

export function MyDropdown(props: IMyDropdownProps) {

    const { id, labelText, gridArea, isVisible, isRequired, onChange, options, submitClicked } = props;
    const [selected, setSelected] = React.useState<string | number | null>(null);
    const onSelectedOption = (_ev: React.FormEvent<HTMLDivElement>, option: IDropdownOption) => {
        setSelected(option.key);
        onChange({ [id]: option.key });
    };

    const showError = () => {
        if (submitClicked && !selected && isRequired) return "  ";
        return undefined;
    };

    return (
        <Dropdown
            selectedKey={selected}
            options={options}
            label={labelText}
            disabled={!isVisible}
            required={isRequired}
            onChange={onSelectedOption}
            errorMessage={showError()}
            responsiveMode={ResponsiveMode.large}
            className={`ms-Custom-Field ${!isVisible && 'ms-Hidden-Field'}`}
            styles={{ root: { gridColumn: gridArea, gridRow: gridArea }, label: "ms-Custom-Label" }}
        />
    );
}
